module.exports = __webpack_public_path__ + "img/diyCardTitleLong.f0b9bacc.png";